import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { CommandeService } from 'src/app/core/services/commande.service';
import { ToastService } from 'src/app/core/services/toast.service';

@Component({
  selector: 'app-depotage',
  templateUrl: './depotage.component.html',
  styleUrls: ['./depotage.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DepotageComponent implements OnInit {

  commandes: any[] = [];
  commandesFiltrees: any[] = [];
  indicateurChargement = true;

  pageCourante = 1;
  taillePage = 30;
  totalElements = 0;
  recherche = '';
  statutFiltre = 'AU_DEPOT';

  readonly STATUTS_DEPOT = [
    { valeur: 'AU_DEPOT',        libelle: 'Au dépôt' },
    { valeur: 'EN_TRI',          libelle: 'En tri' },
    { valeur: 'EN_TRANSIT',      libelle: 'En transit' },
    { valeur: 'RECEPTIONNE',     libelle: 'Réceptionné' },
    { valeur: 'EN_DISTRIBUTION', libelle: 'En distribution' },
  ];

  readonly FILTRES = [
    { valeur: '', libelle: 'Tous (dépôt/tri)' },
    ...this.STATUTS_DEPOT
  ];

  constructor(
    private commandeService: CommandeService,
    private router: Router,
    private toast: ToastService
  ) {}

  ngOnInit(): void {
    this.charger();
  }

  charger(): void {
    this.indicateurChargement = true;
    // Load all interurban orders then filter locally
    this.commandeService.obtenirCommandesInterurbaines(0, 200).subscribe({
      next: (data: any) => {
        const all: any[] = data?.content ?? [];
        // Keep only depot-related statuses
        this.commandes = all.filter(c =>
          ['STANDARD_INTERURBAIN'].includes((c.typeEnvoi || '').toString()) &&
          ['AU_DEPOT', 'EN_TRI', 'EN_TRANSIT', 'RECEPTIONNE', 'EN_DISTRIBUTION'].includes(c.statut)
        );
        this.totalElements = this.commandes.length;
        this.appliquerFiltres();
        this.indicateurChargement = false;
      },
      error: () => { this.indicateurChargement = false; }
    });
  }

  appliquerFiltres(): void {
    let r = [...this.commandes];
    if (this.statutFiltre) {
      r = r.filter(c => c.statut === this.statutFiltre);
    }
    if (this.recherche.trim()) {
      const q = this.recherche.toLowerCase();
      r = r.filter(c =>
        (c.numeroCommande ?? '').toLowerCase().includes(q) ||
        (c.expediteur?.nom ?? '').toLowerCase().includes(q) ||
        (c.destinataire?.nom ?? '').toLowerCase().includes(q)
      );
    }
    this.commandesFiltrees = r;
  }

  progresserStatut(c: any): void {
    // EN_TRI → EN_TRANSIT passe obligatoirement par un manifeste (pas de bouton direct)
    const progressions: Record<string, string> = {
      'AU_DEPOT':      'EN_TRI',
      'RECEPTIONNE':   'EN_DISTRIBUTION',
      'EN_DISTRIBUTION': 'EN_LIVRAISON',
    };
    const suivant = progressions[c.statut];
    if (!suivant) return;
    this.commandeService.mettreAJourStatutCommande(c.id, suivant).subscribe({
      next: () => {
        this.toast.succes(`Commande ${c.numeroCommande ?? '#' + c.id} → ${suivant}`);
        this.charger();
      },
      error: () => this.toast.erreur('Erreur lors de la mise à jour')
    });
  }

  libelleProchainStatut(statut: string): string {
    const map: Record<string, string> = {
      'AU_DEPOT':        'Mettre en tri',
      // EN_TRI : pas de bouton — transit uniquement via manifeste
      'RECEPTIONNE':     'Mettre en distribution',
      'EN_DISTRIBUTION': 'Mettre en livraison',
    };
    return map[statut] ?? '';
  }

  infoStatut(statut: string): string {
    if (statut === 'EN_TRI') return 'Créer un manifeste pour expédier ce colis';
    if (statut === 'EN_TRANSIT') return 'En cours de transit (manifeste en route)';
    return '';
  }

  compterParStatut(s: string): number {
    return this.commandes.filter(c => c.statut === s).length;
  }

  badgeStatut(s: string): string {
    const map: Record<string, string> = {
      AU_DEPOT: 'badge--violet', EN_TRI: 'badge--orange',
      EN_TRANSIT: 'badge--bleu', RECEPTIONNE: 'badge--teal',
      EN_DISTRIBUTION: 'badge--vert-clair',
    };
    return map[s] ?? 'badge--gris';
  }

  libelleStatut(s: string): string {
    return this.STATUTS_DEPOT.find(x => x.valeur === s)?.libelle ?? s;
  }

  voirDetail(id: number): void {
    this.router.navigate(['/commande', id]);
  }

  readonly Math = Math;
}
